import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'web-ui-components/lib/atoms/buttons';

const RetryOption = ({ handleRetry, message, retryButtonLabel }) => (
	<div id="retry-option" className="u-padding-2 u-text-align-center">
		<p>{message}</p>
		<Button id="retry-button" display="primary" onClick={handleRetry}>
			{retryButtonLabel}
		</Button>
	</div>
);

RetryOption.propTypes = {
	message: PropTypes.string.isRequired,
	retryButtonLabel: PropTypes.string.isRequired,
	handleRetry: PropTypes.func.isRequired,
};
export default RetryOption;
